import { useEffect } from 'react';

import { useAppDispatch } from 'features/app/hooks';
import { CallDetailsStatus } from 'features/call/call-details/enums';
import { setCallDetailsCalleeStatus } from 'features/call/call-details/store';
import { ParticipantsStatusEventBus } from 'features/call/call-status/services';
import { useWhileComponentMounted } from 'features/utils/hook';
import { checkAndUpdateCallee } from 'features/call/call-base/store';

export function useCallDetailsStatusHandler() {
  const whileComponentMounted = useWhileComponentMounted();
  const dispatch = useAppDispatch();

  const handleStatusHearingCalleeConnected = () => {
    dispatch(
      setCallDetailsCalleeStatus({
        isDeafParticipant: false,
        status: CallDetailsStatus.CALLEE_CONNECTED,
      })
    );
    dispatch(checkAndUpdateCallee());
  };

  const handleStatusHearingCalleeReconnect = () => {
    dispatch(
      setCallDetailsCalleeStatus({
        isDeafParticipant: false,
        status: CallDetailsStatus.CALLEE_RECONNECT,
      })
    );
  };

  const handleStatusDeafCalleeConnected = () => {
    dispatch(
      setCallDetailsCalleeStatus({
        isDeafParticipant: true,
        status: CallDetailsStatus.CALLEE_CONNECTED,
      })
    );
  };

  const handleStatusDeafCalleeReconnect = () => {
    dispatch(
      setCallDetailsCalleeStatus({
        isDeafParticipant: true,
        status: CallDetailsStatus.CALLEE_RECONNECT,
      })
    );
  };

  useEffect(() => {
    ParticipantsStatusEventBus.hearing.$connecting
      .pipe(whileComponentMounted())
      .subscribe(handleStatusHearingCalleeConnected);

    ParticipantsStatusEventBus.hearing.$connected
      .pipe(whileComponentMounted())
      .subscribe(handleStatusHearingCalleeConnected);

    ParticipantsStatusEventBus.hearing.$disconnected
      .pipe(whileComponentMounted())
      .subscribe(handleStatusHearingCalleeReconnect);

    ParticipantsStatusEventBus.deaf.$connecting
      .pipe(whileComponentMounted())
      .subscribe(handleStatusDeafCalleeConnected);

    ParticipantsStatusEventBus.deaf.$connected
      .pipe(whileComponentMounted())
      .subscribe(handleStatusDeafCalleeConnected);

    ParticipantsStatusEventBus.deaf.$disconnected
      .pipe(whileComponentMounted())
      .subscribe(handleStatusDeafCalleeReconnect);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
